/**
 * Created by Dongyuhua on 2018/3/12.
 */
module.exports = {
  common:{
    more:"更多",
    videos:"视频",
    news:'新闻',
    showMore:"查看详情",
    companyName:"速得尔科技（北京）有限公司"

  },
  comheader: {
    nav:[{
      title:"电子靶",
      url:"/etarget",
    },{
      title:"激光射击",
      url:"/lasershooting",
    },{
      title:"智能靶场",
      url:"/erange",
    },{
      title:"软件与服务",
      url:"/service",
    },{
      title:"关于我们",
      url:"/about/intro",
    }]
  },
  comfooter:{
    title:"联系我们",
    subtitle:"",
    contextInfo:[
      "速得尔科技（北京）有限公司",
      "服务热线： 4006-747-313",
      "总机：010-82093400",
      "传真：010-82093499",
      "网址：www.suooter.com",
      "邮箱：info@suooter.com",
      "地址：北京市德外西三旗桥北金燕龙大厦三层",
      "邮编：100096"
    ],
    ewm:[
        {url:"./static/erweima-1.png",
        intro:"速得尔微信公众号"},
      {url:"../static/erweima-2.png",
        intro:"www.suooter.com"},
    ],
  },
  main:{
    mainBanner:{
      banner:[
        {
          img:'../static/banner-1.jpg',
          title:'',
          link:'/article/24',
        },
        {
          img:'../static/banner-2.jpg',
          title:'',
          link:'/article/23',
        },
        {
          img:'../static/banner-3.jpg',
          title:'',
          link:'/article/22',
        },
      ]
    },
    mainProduct:{
      title:"产品与系统",
      subtitle:"Product & System",
      intro:[
        {
          linkUrl:'/etarget',
          title:"电子靶",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。我国于20世纪70年代开发气动靶式流量计变送器，",
          imgUrl:'../static/product-1.png'
        },
        {
          linkUrl:'/lasershooting',
          title:"激光射击",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量。",
          imgUrl:'../static/product-2.png'
        },
        {
          linkUrl:'/erange',
          title:"智能靶场",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。",
          imgUrl:'../static/product-3.png'
        },
        // {
        //   linkUrl:'/etarget?idx=6',
        //   title:"射击耗材",
        //   imgUrl:'../static/product-4.png'
        // },
      ]
    },
    mainService:{
      title:"软件与服务",
      subtitle:"Software & Service",
      intro:[
        {
          linkUrl:'/service?idx=1',
          title:"赛事直播",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。我国于20世纪70年代开发气动靶式流量计变送器，",
          imgUrl:'../static/server-1.png'
        },
        {
          linkUrl:'/service?idx=0',
          title:"超级射手",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。我国于20世纪70年代开发气动靶式流量计变送器，",
          imgUrl:'../static/server-2.png'
        },
        {
          linkUrl:'/service?idx=2',
          title:"大数据服务",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。我国于20世纪70年代开发气动靶式流量计变送器，",
          imgUrl:'../static/server-3.png'
        },
        {
          linkUrl:'/service?idx=3',
          title:"赛事支持",
          content:"靶式流量计应用于工业流量测量已有数十年的历史，主要用于解决高粘度、低雷诺数流体的流量测量，先后经历了机械式和电动表两大发展阶段。我国于20世纪70年代开发气动靶式流量计变送器，",
          imgUrl:'../static/server-4.png'
        },
      ]
    },
    mainHonor:{
      title:"荣誉与成就",
      subtitle:"Honor & Achievement",
      intro:[
        {
          linkUrl:'#',
          title:"中国射击协会射击器材设备鉴定证书",
          imgUrl:'../static/honor-1.png'
        },
        {
          linkUrl:'#',
          title:"高新技术企业证书",
          imgUrl:'../static/honor-2.png'
        },
        {
          linkUrl:'#',
          title:"中关村信用促进会VIP会员单位",
          imgUrl:'../static/honor-3.png'
        },
        {
          linkUrl:'#',
          title:"速得尔拥有电子靶核心专利",
          imgUrl:'../static/honor-4.png'
        },
      ]
    },
    mainNews:{
      title:"赛事与新闻",
      subtitle:"Events & News",
      intro:[
        {
          linkUrl:'#',
          title:"中国射击协会射击器材设备鉴定证书",
          imgUrl:'../static/honor-1.png'
        },
        {
          linkUrl:'#',
          title:"高新技术企业证书",
          imgUrl:'../static/honor-2.png'
        },
        {
          linkUrl:'#',
          title:"中关村信用促进会VIP会员单位",
          imgUrl:'../static/honor-3.png'
        },
        {
          linkUrl:'#',
          title:"速得尔拥有电子靶核心专利",
          imgUrl:'../static/honor-4.png'
        },
      ]
    }
  },
  eTarget:{ //电子靶数据信息
    secondnav:[
      {
        title:"10米声学靶",
        icon:"../static/10msheng.png",
        activeIcon:"../static/10msheng-fill.png",
        index:0,
      },
      {
        title:"25米/50米声学靶",
        icon:"../static/25msheng.png",
        activeIcon:"../static/25msheng-fill.png",
        index:1,
      },
      {
        title:"10米光学靶",
        icon:"../static/10mguang.png",
        activeIcon:"../static/10mguang-fill.png",
        index:2,
      },
      {
        title:"25米/50米光学靶",
        icon:"../static/25mguang.png",
        activeIcon:"../static/25mguang-fill.png",
        index:3,
      },
      {
        title:"冲刺射击靶",
        icon:"../static/ccsj.png",
        activeIcon:"../static/ccsj-fill.png",
        index:4,
      },
      {
        title:"军/警用电子靶",
        icon:"../static/jingyong.png",
        activeIcon:"../static/jingyong-fill.png",
        index:5,
      },
    ],
    title:"电子靶",
    titleIcon:"../static/dianziba-img@2x.png",
    tabs:[
      {title:"10米声学电子靶",
        subTitle:"ST10T",
        intro:["速得尔10米声学电子靶系统是中国射击协会认证的电子靶系统. 速得尔是中国射击电子靶行业的领导品牌，产品性能优越，性价比高，受到业内人士广泛认可。"],
        foundImg:"../static/10米声学.png",
        icon:"../static/shengxue.png",
        tags:["CSA认证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["ST10T适用于气手枪、气步枪项目","比赛控制系统支持所有10米气枪项目","最佳性价比的声学电子靶系统","更容易操控的触控屏","竞赛及训练的理想设备","广泛被中国客户认可的电子靶","唯一经过中国射击协会认证电子靶统"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米声学靶"}]
      },
      {
        title:"25米/50米声学电子靶",
        subTitle:"ST25T/50T",
        intro:["速得尔25米/50米声学电子靶系统是中国射击协会认证的电子靶系统. 速得尔是中国射击电子靶行业的领导品牌，产品性能优越，性价比高，受到业内人士广泛认可。"],
        foundImg:"../static/2550声学.png",
        icon:"../static/shengxue.png",
        tags:["CSA唯证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["ST25T/50T适用于所有运动手枪项目","比赛控制系统支持所有25米/50米项目","最佳性价比的声学电子靶系统","更容易操控的触控屏","竞赛及训练的理想设备","广泛被中国客户认可的电子靶","唯一经过中国射击协会认证电子靶统"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米声学靶"}]
      },
      {
        title:"10米光学电子靶",
        subTitle:"ST10L",
        intro:["速得尔10米光学电子靶系统是中国射击协会认证的电子靶系统. 速得尔是中国射击电子靶行业的领导品牌，产品性能优越，性价比高，受到业内人士广泛认可。"],
        foundImg:"../static/10米光学.png",
        icon:"../static/shengxue.png",
        tags:["CSA唯证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["ST10L适用于气手枪、气步枪项目","比赛控制系统支持所有10米气枪项目","最佳性价比的光学电子靶系统","免耗材、可靠性强","更容易操控的触控屏","竞赛及训练的理想设备","广泛被中国客户认可的电子靶","唯一经过中国射击协会认证电子靶统"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米光学靶"}]
      },
      {
        title:"25米/50米光学电子靶",
        subTitle:"ST25L/50L",
        intro:["速得尔25米/50米光学电子靶系统是中国射击协会认证的电子靶系统. 速得尔是中国射击电子靶行业的领导品牌，产品性能优越，性价比高，受到业内人士广泛认可。"],
        foundImg:"../static/2550光学.png",
        icon:"../static/shengxue.png",
        tags:["CSA唯一认证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["ST25L/50L适用于所有运动手枪项目","比赛控制系统支持所有25米/50米项目","最佳性价比的光学电子靶系统","免耗材、可靠性强","更容易操控的触控屏","竞赛及训练的理想设备","广泛被中国客户认可的电子靶","唯一经过中国射击协会认证电子靶统"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米声学靶"}]
      },
      {
        title:"冲刺射击靶",
        subTitle:"SSST",
        intro:["冲刺射击是将冲刺短跑与步枪射击有机结合的运动项目，由国际射联在2013年推出并在国际射联青少年世界杯中多次成功举行。速得尔率先在国内研制出符合国际射联要求的冲刺射击电子靶。"],
        foundImg:"../static/冲刺射击.png",
        icon:"../static/shengxue.png",
        tags:["CSA唯一认证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["电子自动报靶系统，更加便捷高效","射击靶盖自动复位系统，降低操作风险","无线数据传输，稳定、可靠、便捷","智能比赛系统，实时监测比赛全程","毫秒级比赛计时系统，精准可靠"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米声学靶"}]
      },
      {
        title:"军/警用电子靶",
        subTitle:"STPA",
        intro:["速得尔25米/50米光学电子靶系统是中国射击协会认证的电子靶系统. 速得尔是中国射击电子靶行业的领导品牌，产品性能优越，性价比高，受到业内人士广泛认可。"],
        foundImg:"../static/foundjingyong.png",
        icon:"../static/shengxue.png",
        tags:["CSA唯一认证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["STPA适用于所有军事射击训练项目","比赛控制系统支持300米军警项目","最佳性价比的声学电子靶系统","更容易操控的触控屏","竞赛及训练的理想设备","唯一经过中国射击协会认证电子靶"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"XXXX靶场10米声学靶"}]
      },

    ],
  },
  shoot:{ //激光射击数据信息
    secondnav:[
      {
        title:"专业激光射击系统P型",
        icon:"../static/p-1.png",
        activeIcon:"../static/p-2.png",
        index:0,
      },
      {
        title:"专业激光射击系统R型",
        icon:"../static/R-1.png",
        activeIcon:"../static/R-2.png",
        index:1,
      },
    ],
    title:"激光射击",
    titleIcon:"../static/激光手枪.jpg",
    tabs:[
      {title:"专业激光射击系统P型",
        subTitle:"LT10P",
        intro:["全国首款可用于正式比赛的专业激光射击系统，高度还原真实运动气手枪体验，包含射击轨迹，无缝接入速得尔电子靶系统，是射击运动选材与普及的利器。"],
        foundImg:"../static/激光手枪.png",
        tags:["欧盟认证","公安部认证","一类安全激光","轨迹","高精度"],
        merits:["获得公安部软件系统安全认证","获得欧盟安全激光认证（Class1）","高度模拟真实运动枪支体验","报靶精度高于ISSF及中国射击协会要求","无缝接入速得尔电子靶系统","安装方便、操作简单"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"配激光模拟射击图片和文字说明"}]
      },
      {title:"专业激光射击系统R型",
        subTitle:"LT10R",
        intro:["全国首款可用于正式比赛的专业激光射击系统，高度还原真实运动气步枪体验，包含射击轨迹，无缝接入速得尔电子靶系统，是射击运动选材与普及的利器。"],
        foundImg:"../static/激光步枪.png",
        tags:["欧盟认证","公安部认证","一类安全激光","轨迹","高精度"],
        merits:["获得公安部软件系统安全认证","获得欧盟安全激光认证（Class1）","高度模拟真实运动枪支体验","报靶精度高于ISSF及中国射击协会要求","无缝接入速得尔电子靶系统","安装方便、操作简单"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"配激光模拟射击图片和文字说明"}]
      },
    ],
  },
  erange:{ //智能靶场数据信息
    secondnav:[
      {
        title:"智能枪弹柜",
        icon:"../static/gui-2.png",
        activeIcon:"../static/gui.png",
        index:0,
      },
    ],
    title:"智能靶场",
    titleIcon:"../static/jiguang.png",
    tabs:[
      {title:"智能枪弹柜",
        subTitle:"SGBM-V10",
        intro:["速得尔枪弹柜系统SGBM是速得尔公司在充分了解运动枪弹管理的用户需求基础上，开发出来的符合监管要求的运动枪弹管理和储存系统。整个产品系列包含运动枪柜SGBM-Q-V10、运动弹柜SGBM-D-V10和控制柜SGBM-K-V10。本系统以安全和可追溯为目标，充分考虑了射击训练与竞赛的需求。该系统可与速得尔电子靶系统配合，使枪弹管理更加精细化。","速得尔枪弹柜系统SGBM采用标准接口，可与其它安防系统如门禁、闸机、人脸识别、RFID系统等集成。速得尔可提供符合国家安全标准的运动枪弹库的信息化和安全管理的整体解决方案，已有多处成功实施经验。"],
        foundImg:"../static/智能枪弹柜.png",
        tags:["安全","可追溯","公安部认证","靶场精细化管理"],
        merits:["采用多重警报与应急设置，防止、监控意外情况发生","与速得尔电子靶系统无缝结合","采用生物识别与RFID技术，实现快速精确身份识别和枪弹跟踪","采用总线加密通信与信息实时存档确保信息安全","了解监管要求，方便监管接入","深刻理解日常使用场景，在安全管理的前提下，方便用户使用","枪柜、弹柜及管理软件都获得了公安部认证"],
        introImgs:[{imgs:"../static/target_10m_qbp5.png",description:"配智能靶场图片和文字说明"}]
      },
    ],
  },
  service:{ //软件与服务数据信息
    secondnav:[
      {
        title:"超级射手",
        icon:"../static/super-shoter.png",
        activeIcon:"../static/super-shoter-fill.png",
        name:"supershooter",
        index:0,
      },
      {
        title:"赛事直播",
        icon:"../static/saishiplay.png",
        activeIcon:"../static/saishiplay-fill.png",
        name:"live",
        index:1,
      },
      {
        title:"大数据训练辅助",
        icon:"../static/data.png",
        activeIcon:"../static/data-fill.png",
        name:"bigdata",
        index:2,
      },
      {
        title:"赛事服务",
        icon:"../static/cup.png",
        activeIcon:"../static/cup-fill.png",
        name:"competitionservice",
        index:3,
      },
      {
        title:"售后服务",
        icon:"../static/service.png",
        activeIcon:"../static/service-fill.png",
        name:"aftersaleservice",
        index:4,
      },
    ],
    tabs:[
      {title:"超级射手",
        subTitle:"SUPER SHOOTER",
        intro:["超级射手是全球首款运动射击竞训数据平台。超级射手拥有赛事直播、弹着分析和线上比赛三大功能，是射击运动员与教练员必备的训练辅助系统。"],
        foundImg:"../static/超级射手.png",
        icon:"../static/shengxue.png",
        ewm:"../static/erweima-chaojisheshou.png",
        tags:["CSA认证","高精度","高可靠性","高性价比","全国赛事考验","市场主导"],
        merits:["全球首款运动射击竞训数据平台","随时随地查看比赛训练情况","完整展示弹着点分布、辅助训练","观看重要赛事直播","创建比赛、线上约战","手机注册即用，无需安装APP"],
        introImgs:[]
      },
      {
        title:"赛事直播",
        subTitle:"LIVE MATCHES",
        foundImg:"../static/赛事直播.png",
        intro:["全国首款射击比赛直播系统，免费观看全国及省级比赛。曾在第十三届全运会上通过互联网为全国观众直播全运会射击比赛。"],
        tags:[
          {
            title:"免费",
            icon:"../static/mainfei.png"
          },
          {
            title:"注册可用",
            icon:"../static/xinxi.png"
          },
          {
            title:"全部赛事",
            icon:"../static/bisai-cup.png"
          },
        ],
        merits:["全国首款射击赛事比分直播系统","获得十三届全运会组委会嘉奖","可观看全国及省级比赛即时比分","免费使用，无需安装注册"],
        introImgs:[{imgs:"../static/chengabn.png",description:"速得尔获得十三届全运会组委会嘉奖"}]
      },
      {
        title:"大数据训练辅助",
        subTitle:"BIGDATA TRAINING",
        foundImg:"../static/大数据服务2.png",
        intro:["由全国著名射击教练牵头，结合丰富的赛事和训练数据，利用大数据技术提高训练效果"],
        meritsTitle:"特色",
        merits:["全国著名教练牵头组织","以全国各项赛事300多万组数据为基础","结合现代生物学、体育心理学","为客户制定个性化成绩提升方案","已为全国多地射击队提供服务"],
        introImgs:[{imgs:"../static/chengabn.png",description:"配智能靶场图片和文字说明"}]
      },
      {
        title:"赛事服务",
        subTitle:"MATCHES SERVICES",
        intro:["速得尔赛事服务团队每年服务全国50多场射击赛事，经验丰富，态度严谨，专业技术过硬，曾为速得尔获得过十三届全运会组委会《优秀赛事承办单位》称号。"],
        foundImg:"../static/赛事服务.png",
        merits:["多次获得全国及省级比赛优秀保障团队奖","每年支持50多场射击比赛","团队包括4位北京市一级射击裁判","所有赛事支持人员均拥有大学以上学历","熟悉国内外所有电子靶及比赛设备的操作"],
      },
      {
        title:"售后服务",
        subTitle:"SALE SERVICE",
        intro:["速得尔售后服务团队每年出差260多天，奔走于全国100多个靶场和客户之间，为客户提供一站式的售后服务。"],
        foundImg:"../static/售后服务.png",
        merits:["7×24小时全方位售后服务","全国48小时到达现场","定期产品巡检","年度产品培训"],

      }

    ],
  },
  about: { //软件与服务数据信息
    secondnav: [
      {
        title: "企业介绍",
        icon: "../static/qiye-line.png",
        activeIcon: "../static/qiye-fill.png",
        name: "intro",
      },
      {
        title: "企业荣誉",
        icon: "../static/rongyu-line.png",
        activeIcon: "../static/rongyu-fill.png",
        name: "honor",
      },
      {
        title: "战略客户",
        icon: "../static/kehu-line.png",
        activeIcon: "../static/kehu-fill.png",
        name: "customer",
      },
      {
        title: "联系我们",
        icon: "../static/lianxi-line.png",
        activeIcon: "../static/lianxi-fill.png",
        name: "contact",
      }
    ],
    intro:{
      foundImg:"../static/guanyu-banner.png",
      merits:["速得尔（SUOOTER） 源于英文 SUper shOOTER，意为“超级射手”。企业的名称也是我们奋斗的方向，那就是全力服务中国射击事业，为中国培养更多的超级射手。2007年速得尔借着北京奥运会的东风，立项研发中国国产的电子靶系统。速得尔从北京开始，如今，全国28个省市自治区100多个射击靶场，都在使用速得尔的产品。速得尔每年派出千余人次分赴全国各地，为全国及省市50多场重大射击赛事提供技术支持。速得尔也由最初的5个人，成长为拥有两位博士，7位硕士，90%以上拥有本科学历，总人数近百人的的高素质团队。","速得尔，已经成为中国射击装备领域的领导品牌。"],
      intro:"速得尔科技（北京）有限公司成立于2012年，依托于高校优势资源，成立初期研制出速得尔电子靶自动报靶系统、比赛控制系统、比赛排名系统。速得尔科技（北京）有限公司是北京市中关村高新技术企业协会会员单位，中关村信用促进会VIP会员单位。具有本科以上学历的员工占95%以上，是一支高素质团队。"
    },
    honor:{
      tags:[
        {
          title:"2017",
          subtitle:"第十三届全运会《优秀赛事承办单位》",
          foundImg:"../static/r-img-1.png"
        },
        {
          title:"2016",
          subtitle:"速得尔获得全国U17射击锦标赛，全国大学生射击锦标赛特别贡献奖。",
          foundImg:"../static/r-img-2.png"
        },
        {
          title:"2015",
          subtitle:"速得尔先后获得中关村高成长企业TOP100和北京市诚信创建企业等多项称号。",
          foundImg:"../static/r-img-3.png"
        },
        {
          title:"2014",
          subtitle:"速得尔获得国家级高新技术企业称号。",
          foundImg:"../static/r-img-4.png"
        },
        {
          title:"2013",
          subtitle:"速得尔电子靶系统通过中国射击协会认证，成为该领域唯一获得认可的企业。",
          foundImg:"../static/r-img-5.png"
        }
      ],
    },
    customer:{
      title:"战略客户",
      subtitle:"",
      foundImg:"../static/map.png",
      meritsTitle:"战略客户",
      merits:["贵州毕节市体育运动学校","安徽省射击运动管理中心","陕西省射击射箭运动管理中心","河北张家口少业余运动学校","河南省射击射箭运动管理中心","浙江杭州射击运动管理中心","湖北省体育局射击运动管理中心","四川成都运动学校","云南省北教场体育训练基地","湖南省射击运动管理中心","福建省射击射箭运动管理中心","江苏省方山体育训练基地","山东省济宁市体育局","甘肃兰州体育运动学校","江西南昌湾里射击中心","黑龙江省射击射箭运动管理中心","新疆克拉玛依体育局"],
    },
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/en.js